import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=64b8cbce&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=js"
export * from "./datetime.vue?vue&type=script&lang=js"
import style0 from "./datetime.vue?vue&type=style&index=0&id=64b8cbce&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b8cbce",
  null
  
)

export default component.exports